/* eslint-disable max-lines */
import { InlineMessage } from '@strata/react-inline-message';
import FlagIcon from '@strata/strata-ui/assets/logos/f-mark-orange.svg';
import OneLineLogo from '@strata/strata-ui/assets/logos/free-market-health-logo.svg';
import StackedLogo from '@strata/strata-ui/assets/logos/free-market-health-stacked-logo.svg';

import { Columns } from 'components/shared/Columns';
import { ImgWithBackground } from 'components/shared/ImgWithBackground';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const ourLogo = [
    <Columns
        key="1"
        columns={Columns.ColumnNumber.TWO}
        content={
            <>
                <div>
                    <h4>Primary Logo</h4>
                    <p>
                        This is the preferred logo and should be used unless design restrictions
                        prevent it.
                    </p>
                    <img
                        className="margin__top--small"
                        style={{ width: 200 }}
                        src={StackedLogo}
                        alt="Free Market Health primary logo"
                        loading="lazy"
                    />
                </div>
                <div>
                    <h4>Clear Space</h4>
                    <p>
                        Ensure text or other elements are not too close to logos by using the clear
                        space guidelines. For the primary logo, the clear space is equal to the size
                        of the F.
                    </p>
                    <img
                        className="margin__top--small"
                        style={{ width: 200 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/primary-logo-clear-space.svg"
                        alt="Free Market Health primary logo with clear space"
                        loading="lazy"
                    />
                </div>
            </>
        }
    />,
];

const altLogo = [
    <div key="2">
        <h4>One-Line Logo</h4>
        <p>This version of the logo is to be used when vertical space is limited.</p>
        <img
            className="margin__top--medium"
            style={{ width: 450, display: 'block' }}
            src={OneLineLogo}
            alt="Free Market Health one-line logo"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 450 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/one-line-logo-clear-space.svg"
            alt="Free Market Health one-line logo with clear space"
            loading="lazy"
        />
    </div>,
    <div key="3">
        <h4>Short Logo</h4>
        <p>
            This version of the logo is to be used when both horizontal and vertical space are
            limited, and when the full logo has already been displayed.
        </p>
        <img
            className="margin__top--medium"
            style={{ width: 200, display: 'block' }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/short-logo.svg"
            alt="Free Market Health short logo"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 200 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/short-logo-clear-space.svg"
            alt="Free Market Health short logo with clear space"
            loading="lazy"
        />
    </div>,
];

const flag = [
    <Columns
        key="4"
        columns={Columns.ColumnNumber.TWO}
        content={
            <>
                <div>
                    <h4>Flag Icon</h4>
                    <p>
                        The flag icon is to be used for social media, profiles, when space is
                        extremely limited, and when the full logo already has been displayed.
                    </p>
                    <img
                        className="margin__top--small"
                        style={{ width: 100 }}
                        src={FlagIcon}
                        alt="Free Market Health flag icon"
                        loading="lazy"
                    />
                </div>
                <div>
                    <h4>Clear Space</h4>
                    <p>
                        The clear space for the flag icon is equal to the width of the bar within
                        the F.
                    </p>
                    <img
                        className="margin__top--small"
                        style={{ width: 100 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/flag-icon-clear-space.svg"
                        alt="Free Market Health flag icon with clear space"
                        loading="lazy"
                    />
                </div>
            </>
        }
    />,
];

const appLogos = [
    <p key="5">These logos can be use to represent FMH external applications.</p>,
    <div key="6">
        <h4>FMH for Payers Square Logo</h4>
        <p>This logo can be used when horizontal space is limited.</p>
        <img
            className="margin__top--medium"
            style={{ width: 250, display: 'block' }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/payers-logo.svg"
            alt="Free Market Health FMH for Payers square logo"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 250 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/payers-logo-clear-space.svg"
            alt="Free Market Health FMH for Payers square logo with clear space"
            loading="lazy"
        />
    </div>,
    <div key="7">
        <h4>FMH for Payers One-Line Logo</h4>
        <p>This logo can be used when vertical space is limited.</p>
        <img
            className="margin__top--medium"
            style={{ width: 300, display: 'block' }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/payers-one-line-logo.svg"
            alt="Free Market Health FMH for Payers one-line logo"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 300 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/payers-one-line-logo-clear-space.svg"
            alt="Free Market Health FMH for Payers one-line logo with clear space"
            loading="lazy"
        />
    </div>,
    <div key="8">
        <h4>FMH for Pharmacies Square Logo</h4>
        <p>This logo can be used when horizontal space is limited.</p>
        <img
            className="margin__top--medium"
            style={{ width: 300, display: 'block' }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-logo.svg"
            alt="Free Market Health FMH for Pharmacies square logo"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 300 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-logo-clear-space.svg"
            alt="Free Market Health FMH for Pharmacies square logo with clear space"
            loading="lazy"
        />
    </div>,
    <div key="9">
        <h4>FMH for Pharmacies One-Line Logo</h4>
        <p>This logo can be used when vertical space is limited.</p>
        <img
            className="margin__top--medium"
            style={{ width: 400, display: 'block' }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-one-line-logo.svg"
            alt="Free Market Health FMH for Pharmacies one-line logo"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 400 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-one-line-logo-clear-space.svg"
            alt="Free Market Health FMH for Pharmacies one-line logo with clear space"
            loading="lazy"
        />
    </div>,
];

const sizeCompanyLogos = [
    <p key="10">
        Use the guide below to determine the minimum size for each logo, and to determine the best
        logo for your situation.
    </p>,
    <div key="11">
        <h4>Primary Logo</h4>
        <p>This is the preferred logo and should be used unless design restrictions prevent it.</p>
        <img
            className="margin__top--small"
            style={{ width: 280 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/primary-logo-min-size.svg"
            alt="Free Market Health primary logo with minimum size requirements"
            loading="lazy"
        />
    </div>,
    <div key="12">
        <h4>One-Line Logo</h4>
        <p>Use this logo when vertical space is limited.</p>
        <img
            className="margin__top--small"
            style={{ width: 500 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/one-line-logo-min-size.svg"
            alt="Free Market Health one-line logo with minimum size requirements"
            loading="lazy"
        />
    </div>,
    <div key="13">
        <h4>Short Logo</h4>
        <p>Use this logo when vertical space and horizontal space is limited.</p>
        <img
            className="margin__top--small"
            style={{ width: 225 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/short-logo-min-size.svg"
            alt="Free Market Health short logo with minimum size requirements"
            loading="lazy"
        />
    </div>,
    <div key="14">
        <h4>Flag Icon</h4>
        <p>Use this logo when vertical space and horizontal space is extremely limited.</p>
        <img
            className="margin__top--small"
            style={{ width: 180 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/flag-icon-min-size.svg"
            alt="Free Market Health flag icon with minimum size requirements"
            loading="lazy"
        />
    </div>,
];

const sizeAppLogos = [
    <p key="15">
        Use the guide below to determine the minimum size for each logo, and to determine the best
        logo for your situation.
    </p>,
    <div key="16">
        <h4>FMH for Payers Square Logo</h4>
        <p>Use this logo when horizontal space is limited.</p>
        <img
            className="margin__top--small"
            style={{ width: 280 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/payers-logo-min-size.svg"
            alt="FMH for Payers square logo with minimum size requirements"
            loading="lazy"
        />
    </div>,
    <div key="17">
        <h4>FMH for Payers One-Line Logo</h4>
        <p>Use this logo when vertical space is limited.</p>
        <img
            className="margin__top--small"
            style={{ width: 325 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/payers-one-line-logo-min-size.svg"
            alt="FMH for Payers one-line logo with minimum size requirements"
            loading="lazy"
        />
    </div>,
    <div key="18">
        <h4>FMH for Pharmacies Square Logo</h4>
        <p>Use this logo when vertical space space is limited.</p>
        <img
            className="margin__top--small"
            style={{ width: 325 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-logo-min-size.svg"
            alt="FMH for Pharmacies square logo with minimum size requirements"
            loading="lazy"
        />
    </div>,
    <div key="19">
        <h4>FMH for Pharmacies One-Line Logo</h4>
        <p>Use this logo when vertical space and horizontal space is extremely limited.</p>
        <img
            className="margin__top--small"
            style={{ width: 350 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-one-line-logo-min-size.svg"
            alt="FMH for Pharmacies one-line logo with minimum size requirements"
            loading="lazy"
        />
    </div>,
];

const fullColorBackground = [
    <div key="20">
        <p>
            The full-color logos should be used only on white, black, dark gray, and dark green
            backgrounds.
        </p>
        <p>
            Use the full-color FMH application logos as outlined below. Do not interchange the use
            of black and white text according to preference.
        </p>
        <p>
            Avoid using full-color logos on photographs unless the logo sits on the black or white
            area of the image.
        </p>
    </div>,
    <Columns
        key="21"
        columns={Columns.ColumnNumber.TWO}
        content={
            <>
                <ImgWithBackground
                    imgDescription="Full-color on white"
                    color="#ffffff"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src={StackedLogo}
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Full-color on dark gray"
                    color="#1d1f24"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src={StackedLogo}
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Full-color on black"
                    color="#000000"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src={StackedLogo}
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Full-color on dark green"
                    color="#003035"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src={StackedLogo}
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Full-color on white"
                    color="#ffffff"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-logo-light.svg"
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Full-color on dark gray"
                    color="#1d1f24"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-logo.svg"
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Full-color on black"
                    color="#000000"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-logo.svg"
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Full-color on dark green"
                    color="#003035"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 200, height: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/pharmacies-logo.svg"
                            alt="Free Market Health Logo full-color on white"
                            loading="lazy"
                        />
                    }
                />
            </>
        }
    />,
];

const bwBackground = [
    <div key="22">
        <p>
            The black and white logos should be used only on colored backgrounds shown to below.
            Avoid using one-color logos on photographs unless the logo sits on a black or white area
            of the image.
        </p>
        <p>
            If using white, black, dark gray, or dark green it is always preferred to use the
            full-color logo. If design restrictions prevent the use of full-color logos, the black
            and white logos can be used as outlined below. Do not interchange the use of black or
            white text according to preference.
        </p>
        <p>
            Avoid using one-color logos on photographs unless the logo sits on a black or white area
            of the image.
        </p>
    </div>,
    <Columns
        key="23"
        columns={Columns.ColumnNumber.FOUR}
        content={
            <>
                <ImgWithBackground
                    imgDescription="Black on white"
                    color="#ffffff"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-black.svg"
                            alt="Free Market Health Logo black on white"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Black on light gray"
                    color="#f2f3f7"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-black.svg"
                            alt="Free Market Health Logo black on light gray"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Black on medium light gray"
                    color="#e1e3e9"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-black.svg"
                            alt="Free Market Health Logo black on medium light gray"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Black on medium gray"
                    color="#adb2bf"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-black.svg"
                            alt="Free Market Health Logo black on medium gray"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="White on medium dark gray"
                    color="#606574"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-white.svg"
                            alt="Free Market Health Logo white on medium dark gray"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="White on dark gray"
                    color="#1d1f24"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-white.svg"
                            alt="Free Market Health Logo white on dark gray"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="White on black"
                    color="#000000"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-white.svg"
                            alt="Free Market Health Logo white on black"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Black on orange"
                    color="#f36745"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-black.svg"
                            alt="Free Market Health Logo black on orange"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="White on orange"
                    color="#f36745"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-white.svg"
                            alt="Free Market Health Logo white on orange"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="White on dark green"
                    color="#003035"
                    typeColor="#f2f3f7"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-white.svg"
                            alt="Free Market Health Logo white on dark green"
                            loading="lazy"
                        />
                    }
                />
                <ImgWithBackground
                    imgDescription="Black on green"
                    color="#4fb287"
                    typeColor="#1d1f24"
                    imgContent={
                        <img
                            className="margin__top--large margin__bottom--large"
                            style={{ width: 100 }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/stacked-logo-black.svg"
                            alt="Free Market Health Logo black on green"
                            loading="lazy"
                        />
                    }
                />
            </>
        }
    />,
];

const logoMisuse = [
    <Columns
        key="24"
        columns={Columns.ColumnNumber.TWO}
        content={
            <>
                <div>
                    <InlineMessage
                        wrapText
                        intent={InlineMessage.Intent.ERROR}
                        label="Do not crop logos"
                    />
                    <img
                        className="margin__top--medium"
                        style={{ width: 200 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/incorrect-logo-cropped.svg"
                        alt="Do not crop logos"
                        loading="lazy"
                    />
                </div>
                <div>
                    <InlineMessage
                        wrapText
                        intent={InlineMessage.Intent.ERROR}
                        label="Do not change the transparency of logos"
                    />
                    <img
                        className="margin__top--medium"
                        style={{ width: 200 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/incorrect-logo-transparency.svg"
                        alt="Do not change the transparency of logos"
                        loading="lazy"
                    />
                </div>
                <div>
                    <InlineMessage
                        wrapText
                        intent={InlineMessage.Intent.ERROR}
                        label="Do not use different colors"
                    />
                    <img
                        className="margin__top--medium"
                        style={{ width: 200 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/incorrect-logo-colors.svg"
                        alt="Do not use different colors"
                        loading="lazy"
                    />
                </div>
                <div>
                    <InlineMessage
                        wrapText
                        intent={InlineMessage.Intent.ERROR}
                        label="Do not recreate the logos as it could result in different sized and positioned elements"
                    />
                    <img
                        className="margin__top--medium"
                        style={{ width: 200 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/incorrect-logo-recreate.svg"
                        alt="Do not recreate the logos as it could result in different sized and positioned elements"
                        loading="lazy"
                    />
                </div>
                <div>
                    <InlineMessage
                        wrapText
                        intent={InlineMessage.Intent.ERROR}
                        label="Do not distort the logos"
                    />
                    <img
                        className="margin__top--medium"
                        style={{ width: 200 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/incorrect-logo-distort.svg"
                        alt="Do not distort the logos"
                        loading="lazy"
                    />
                </div>
                <div>
                    <InlineMessage
                        wrapText
                        intent={InlineMessage.Intent.ERROR}
                        label="Do not use drop shadows or other effects"
                    />
                    <img
                        className="margin__top--medium"
                        style={{ width: 200 }}
                        src="https://sseasacdn.blob.core.windows.net/strata-website/incorrect-logo-drop-shadow.svg"
                        alt="Do not use drop shadows or other effects"
                        loading="lazy"
                    />
                </div>
            </>
        }
    />,
];

const partnershipLockup = [
    <div key="25">
        <p>
            The partnership lockup is used for communication around approved Free Market Health
            partnerships.
        </p>
        <p>
            We lock up only the primary and one-line logo with a partner logo, placing the Free
            Market Health logo either to the left or top of the partner&#39;s logo. We add clear
            space between the logos equal to the size of the two Fs, and divide this space in half
            by a vertical or horizontal line. The lines length is equal to the height or width of
            the tallest or widest logo. The line should be black on light backgrounds or white on
            dark backgrounds.
        </p>
        <p>
            Both logos should feel of equal size. Partner logos should be aligned to the center of
            the Free Market Health logo.
        </p>
    </div>,
    <div key="26">
        <h4>Primary Logo Lockup</h4>
        <img
            className="margin__top--medium"
            style={{ width: 310, display: 'block' }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/partnership-stacked-logo-horizontal.svg"
            alt="Free Market Health primary logo with partner logo to right"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 150 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/partnership-stacked-logo-vertical.svg"
            alt="Free Market Health primary logo with partner logo below"
            loading="lazy"
        />
    </div>,
    <div key="27">
        <h4>One-Line Logo Lockup</h4>
        <img
            className="margin__top--medium"
            style={{ width: 500, display: 'block' }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/partnership-one-line-logo-horizontal.svg"
            alt="Free Market Health one-line logo with partner logo to right"
            loading="lazy"
        />
        <img
            className="margin__top--medium"
            style={{ width: 350 }}
            src="https://sseasacdn.blob.core.windows.net/strata-website/partnership-one-line-logo-vertical.svg"
            alt="Free Market Health one-line logo with partner logo below"
            loading="lazy"
        />
    </div>,
];

export const Logos = () => (
    <div>
        <Page
            pageTitle="Logos"
            pageDescription="Best practices and examples of how to use Free Market Health logos."
            pageContent={
                <>
                    <Section title="Our Logo" contentArray={ourLogo} />
                    <Section title="Alternate Logo" contentArray={altLogo} />
                    <Section title="The Flag" contentArray={flag} />
                    <Section title="FMH Application Logos" contentArray={appLogos} />
                    <Section
                        title="Size Restrictions: Company Logos"
                        contentArray={sizeCompanyLogos}
                    />
                    <Section
                        title="Size Restrictions: Application Logos"
                        contentArray={sizeAppLogos}
                    />
                    <Section
                        title="Full Color Logos on Backgrounds"
                        contentArray={fullColorBackground}
                    />
                    <Section
                        title="Black & White Logos on Backgrounds"
                        contentArray={bwBackground}
                    />
                    <Section title="Logo Misuse" contentArray={logoMisuse} />
                    <Section title="Partnership Lockup" contentArray={partnershipLockup} />
                </>
            }
        />
    </div>
);
